export default __webpack_public_path__ + "static/media/GearNavyBlue1.3fd0c58e.jpg";